module.exports = __webpack_public_path__ + "media/npc_dota_hero_leshrac.f62735cb.webm";